export default class ConstraintRule {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/segment/constraint-rule.html'),
            scope: {
                rule: '=',
                rulesList: '=',
                groups: '=',
                operatorGroups: '='
            },
            controller: ConstraintController,
            controllerAs: 'ctrl'
        }
    }
};

class ConstraintController {
    constructor($scope) {
        this.$scope = $scope;
        this.groups = $scope.groups;
        this.operatorGroups = $scope.operatorGroups;
    }

    removeRule() {
        this.$scope.rulesList.splice(this.$scope.rulesList.indexOf(this.$scope.rule), 1);
    }
}

ConstraintController.$inject = ['$scope'];
